import { db } from "./db.js";
import { getFirm } from "./firm.js";

// permission "levels" of each tier
const ADMIN = "admin";
const MANAGER = "manager";
const MEMBER = "member";


async function isAdminOrOwner(uid, firm_id) {
  let firm = await getFirm(firm_id);
  if (uid == firm.owner) {
    return true;
  }
  let membership = await db.doc(`firms/${firm_id}/members/${uid}`).get();
  return (membership && membership.data().role == "admin");
}

/*
Checks if a user can have direct access to a specific feature
*/
function checkPermissions(task, role) {
  if (task == "entityProfile" && canAdmin(role)) {
    // Manage entity profile (e.g., entity contact info, payment info, subscription status)
    return true;
  } else if (task == "inventionDiscosure" && canManage(role)) {
    // Associate/disassociate invention disclosure form to/from patent application(s)
    return true;
  } else if (task == "patentManagement" && canManage(role)) {
    // Import/remove patent application
    return true;
  } else if (task == "patentClientManagement" && canManage(role)) {
    // Assign/change client to/of patent application
    return true;
  } else if (task == "patentFileWrapperDocument" && canManage(role)) {
    // Import/remove image file wrapper documents
    return true;
  } else if (task == "officeActionManagement" && canManage(role)) {
    // Upload/remove office action
    return true;
  } else if (task == "officeActionTasks" && canManage(role)) {
    // Assign/cancel assignment of office action task
    return true;
  } else if (task == "officeActionEdit" && canManage(role)) {
    // Review/edit office action details
    return true;
  } else if (task == "clientManagement" && canAdmin(role)) {
    // Add/edit/remove client
    return true;
  } else if (task == "userManagement" && canAdmin(role)) {
    // Add/remove user
    return true;
  } else if (task == "editMemberInfo" && canAdmin(role)) {
    // Change role of user
    return true;
  } else if (task == "assignMembers" && canManage(role)) {
    // Assign members to a task / anythign related
    return true;
  } else if (task == "invitemembers" && canAdmin(role)) {
    return true;
  } else if (task == "changeDocketingStatusToCompleted" && canManage(role)) {
    return true;
  } else if (task == "assignClient" && canManage(role)) {
    return true;
  } else if (task == "archivePatents" && canAdmin(role)) {
    return true;
  } else if (task == "archiveTrademarks" && canAdmin(role)) {
    return true;
  } else if (task == "manageSubscription" && canAdmin(role)) {
    return true;
  }
  return false;
}

function canManage(role) {
  return role == MANAGER || role == ADMIN;
}

function canAdmin(role) {
  return role == ADMIN;
}

/*
Checks if a user can request access to a specific feature
*/
function requestPermissions(task, role) {
  if (task == "patentManagement" && role == MEMBER) {
    // Import/remove patent application
    return true;
  } else if (task == "patentClientManagement" && role == MEMBER) {
    // Assign/change client to/of patent application
    return true;
  } else if (task == "patentFileWrapperDocument" && role == MEMBER) {
    // Import/remove image file wrapper documents
    return true;
  } else if (task == "officeActionManagement" && role == MEMBER) {
    // Upload/remove office action
    return true;
  } else if (task == "officeActionEdit" && role == MEMBER) {
    // Review/edit office action details
    return true;
  } else if (task == "clientManagement" && role == MANAGER) {
    // Add/edit/remove client
    return true;
  }
  return false;
}

export {
  checkPermissions,
  requestPermissions,
  isAdminOrOwner,
};